import { useEffect, useState } from "react";
import useEbsApiClient from "./useEbsApiClient.js";
import useTwitch from "./useTwitch.js";

export const FOLLOWER_STATUSES = {
  READY_FOR_CREATION: "READY_FOR_CREATION",
  CREATED: "CREATED",
  ALIVE: "ALIVE",
  DECEASED: "DECEASED",
};

export default function useFollowerRaffleLogic() {
  const ebsApiClient = useEbsApiClient();
  const {
    auth,
    bits,
    addPubSubEventListener,
    removePubSubEventListener,
    viewer,
  } = useTwitch();
  const [activeRaffle, setActiveRaffle] = useState(null);
  const [follower, setFollower] = useState(null);
  const [channelInfo, setChannelInfo] = useState(null);

  const dismissRaffle = () => {
    setActiveRaffle(null);
  };

  const enterRaffle = async () => {
    try {
      await ebsApiClient.post("/followers/raffle/participate");
      setActiveRaffle((raffle) => ({ ...raffle, participated: true }));
    } catch (err) {}
  };

  const createFollower = async ({ skinName, color, premium }) => {
    console.log("createFollower:", { skinName, color, premium });
    let transaction = null;

    if (premium) {
      console.log("Premium skin, requesting Bits from user");
      try {
        transaction = await bits.useBitsPromisified(
          channelInfo.premium_skins_bits_sku
        );
      } catch (err) {
        console.log(err);
        console.log("TODO: handle error");
      }
    }

    if (premium && !transaction) {
      // Bailing early since something went wrong with the transaction
      return;
    }

    try {
      await ebsApiClient.post("/followers/me", {
        skin_name: skinName,
        color,
        transaction,
      });
      setFollower((follower) => ({
        ...follower,
        status: FOLLOWER_STATUSES.CREATED,
      }));
    } catch (err) {}
  };

  useEffect(() => {
    (async () => {
      try {
        const { data: channelData } = await ebsApiClient.get("/channel");
        setChannelInfo(channelData);
        const { data: viewerFollower } = await ebsApiClient.get(
          "/followers/me"
        );
        setFollower(viewerFollower);
      } catch (err) {
        // No follower found, silent fail
      }
    })();
  }, []);

  useEffect(() => {
    const fetchRaffle = async () => {
      try {
        const response = await ebsApiClient.get("/followers/raffle");
        setActiveRaffle(response.data);
      } catch (err) {}
    };

    const handleRaffleEnd = (data) => {
      // TODO: replace this by fetching the viewer's follower if they win
      if (data.winning_viewer_id === viewer.id) {
        setFollower({
          status: FOLLOWER_STATUSES.READY_FOR_CREATION,
        });
      }

      // TOOD: expose the 'win/lose' status to the hook consumer and don't clear the raffle right away?
      setActiveRaffle(null);
    };

    addPubSubEventListener("cotl.raffle.start", fetchRaffle);
    addPubSubEventListener("cotl.raffle.end", handleRaffleEnd);

    // TODO: fetch follower on load
    fetchRaffle();

    return () => {
      removePubSubEventListener("cotl.raffle.start", fetchRaffle);
      removePubSubEventListener("cotl.raffle.end", handleRaffleEnd);
    };
  }, []);

  return {
    activeRaffle,
    follower,
    enterRaffle,
    dismissRaffle,
    createFollower,
    premiumBitsCost: Boolean(channelInfo?.premium_skins_bits_sku)
      ? Number(channelInfo?.premium_skins_bits_sku.split("_")[2])
      : null,
  };
}
